import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AddButton from './AddButton'
import List from './List'
import Header from './Header'
import InputConnectorRow from './InputConnectorRow'
import ErrorMessage from 'components/fulcrum/validation/ErrorMessage'
import { displayError } from 'helpers/validator'
import * as R from 'ramda'

export default class InputConnector extends Component {
  static propTypes = {
    values: PropTypes.array.isRequired,
    onCountChange: PropTypes.func.isRequired,
    onConnectorChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    onAdd: PropTypes.func.isRequired,
  }

  onCountChange(index) {
    return (value) => this.props.onCountChange(index, value)
  }

  onConnectorChange(index) {
    return (value) => this.props.onConnectorChange(index, value)
  }

  onRemove(index) {
    return () => this.props.onRemove(index)
  }

  isDuplicate = (row) => {
    const list = R.filter(R.propEq('pinCount', row.pinCount))(this.props.values)
    return R.propSatisfies(
      R.lt(1),
      'length',
    )(list)
  }

  generateRow(row, index) {
    const { source, rules, showError } = this.props
    let error = displayError(row, rules)
    if (R.isEmpty(error) && this.isDuplicate(row))
      error = 'No duplicate connector type allowed.'

    return (
      <div key={index}>
        <InputConnectorRow
          key={index}
          source={source}
          count={row.connectorCount}
          connector={row.pinCount}
          onConnectorChange={this.onConnectorChange(index)}
          onCountChange={this.onCountChange(index)}
          onRemove={this.onRemove(index)}
        />
        <ErrorMessage
          showError={showError}
          error={error}
        />
      </div>
    )
  }

  generateFields() {
    return this.props.values.map((row, index) => (
      this.generateRow(row, index)
    ))
  }

  render() {
    const { onAdd } = this.props
    return (
      <div>
        <List>
          <Header/>
          { this.generateFields() }
        </List>
        <AddButton onClick={onAdd}/>
      </div>
    )
  }
}
